import { RESET_TOPIC_AND_QUIZ, SET_TOPIC_AND_QUIZ } from "../actions/action_types";

export default function currentTopicAndQuizReducer(state = { topic_id: null, quiz_id: null }, action) {
    switch (action.type) {
        case SET_TOPIC_AND_QUIZ:
            return action.payload
        case RESET_TOPIC_AND_QUIZ:
            return { topic_id: null, quiz_id: null }
        default:
            return state
    }
}